import { mapState } from 'vuex';
import SignInForm from '@/components/auth/sign-in/sign-in-form/index.vue';

// @vue/component
export default {
  name: 'sign-in',

  methods: {
    signedIn() {
      // Redirect to profile
      if (window.localStorage.getItem('fitr_return_path')) {
        const link = this.$router.resolve({
          path: window.localStorage.getItem('fitr_return_path'),
        });

        if (
          link.route.name == 'plan_purchase_form' &&
          this.currentUser != undefined &&
          this.currentUser.role == 'coach'
        ) {
          this.$router
            .replace({
              name: 'public_plan',
              params: link.route.params,
            })
            .finally(() => window.localStorage.removeItem('fitr_return_path'));
        } else {
          this.$router
            .replace({
              path: window.localStorage.getItem('fitr_return_path'),
            })
            .finally(() => window.localStorage.removeItem('fitr_return_path'));
        }
      } else {
        if (this.currentUser != undefined && this.currentUser.role == 'coach') {
          // this.$router.replace({ name: 'my_plans_active' });
          this.$router.replace({ name: 'coach_profile_my_accounts' });
        } else {
          this.$router.replace({ name: 'calendar' });
        }
      }
    },
  },

  computed: mapState(['currentUser']),

  components: {
    SignInForm,
  },
};
